import * as React from 'react';
import { __ } from '../helpers/TranslationService';

export function ShowMoreOrLessBtn({ isShowLess, onClick }) {
    const buttonClasses = `show-more-or-less-btn__link ${
        isShowLess ? 'icon-arrowTop' : 'icon-arrowDown'
    }`;
    const caption = __(`${isShowLess ? 'show less' : 'load more'}`, 'dreamlines');
    return (
        <div className="show-more-or-less-btn">
            <a className={buttonClasses} onClick={onClick}>
                {caption}
            </a>
        </div>
    );
}
